import React, { FC, ImgHTMLAttributes } from 'react';

import cone from '../../../../assets/images/svg/cone.svg';
import logoFull from '../../../../assets/images/svg/conomica-cession.svg';
import logoHeader from '../../../../assets/images/svg/conomica-cession-header.svg';
import logoHeaderMobile from '../../../../assets/images/svg/conomica-cession-header-mobile.svg';
import Image from '../Image';

// Фирменные файлы «Conomica цессии» — те же и с теми же именами, что в лендинге группы.
export enum LogoType {
  // мастер-логотип: там, где логотип — главный элемент (вход, онбординг)
  FULL = logoFull,
  // логотип, нарисованный для шапки
  HEADER = logoHeader,
  // он же для узких мест: подпись «цессии» крупнее, чтобы читалась в малом размере
  HEADER_MOBILE = logoHeaderMobile,
  // одна шишка — там, где логотип целиком не помещается
  CONE = cone,
}

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  type: LogoType;
}

const LogoImage: FC<Props> = ({ type, ...props }) => {
  return <Image {...props} src={type.toString()} alt={'Conomica цессии'} />;
};

export default LogoImage;
